export interface IResidenceType {
  id: number;
  description: string;
}
export const residenceTypes: IResidenceType[] = [
  { id: 1, description: 'Residenza' },
  { id: 2, description: 'Dimora abituale' },
  { id: 3, description: 'Domicilio eletto' },
  { id: 4, description: 'Residenza estera' },
  { id: 5, description: '"Presso" per località italiana' },
  { id: 6, description: '"Presso" per località estera' },
  { id: 7, description: 'Ultima residenza italiana' },
  { id: 8, description: 'Residenza temporanea' },
  { id: 9, description: 'Altro' },
  { id: 10, description: 'Revisione onomastica stradale' },
  { id: 11, description: 'Rettifica post accertamenti' }
];

export function getResidenceTypeDescription(id: number): string {
  return residenceTypes.find(type => type.id === id)?.description || '';
}

// ID	DESCRIZIONE
// 1	Residenza
// 2	Dimora abituale
// 3	Domicilio eletto
// 4	Residenza estera
// 5	"Presso" per località italiana
// 6	"Presso" per località estera
// 7	Ultima residenza italiana
// 8	Residenza temporanea
// 9	Altro
// 10	Revisione onomastica stradale
// 11	Rettifica post accertamenti
